import { ErrorBoundary } from '@sentry/react'

import ErrorMessage from '../../components/common/ErrorMessage'
import { AppGlobalError } from '../../components/layout/AppGlobalError'
import QrManager from './QrManager'
import { DatasetSchema, datasetSchema } from './validation'

export const managerEvents = {
  zipcode: {
    next: new Event('zipcode-next'),
  },
  qr: {
    restart: new Event('qr-restart'),
    prev: new Event('qr-prev'),
    next: new Event('qr-next'),
  },
  endform: {
    prev: new Event('endform-prev'),
  },
}

function App({ dataset }: { dataset: DatasetSchema }) {
  const datasetValidation = datasetSchema.safeParse(dataset)

  if (!datasetValidation.success) {
    console.error(datasetValidation.error)

    return <ErrorMessage exitUrl={dataset.fallbackUrl} />
  }
  if (dataset.iziEndRedirect && (dataset.iziEndformJs || dataset.iziEndformCss)) {
    console.warn(
      `Dataset warning combination iziEndRedirect and iziEndformJs or iziEndformCss, having unnecessary file load, redirection is prioritized`,
    )
  }

  return (
    <ErrorBoundary fallback={<AppGlobalError />}>
      <QrManager dataset={dataset} />
    </ErrorBoundary>
  )
}

export default App
